import { css } from 'lit';

import color from '../../utils/get-color-token';

function styles() {
	return css`
		.m-divider {
			border: 0;
			border-block-end: solid 1px ${color('color-divider')};
			margin-block-start: var(
				--m-divider-margin-top,
				var(--m-divider-margin-y, 0)
			);
			margin-block-end: var(
				--m-divider-margin-bottom,
				var(--m-divider-margin-y, 0)
			);
		}
	`;
}

export default styles;
